import { Artist, Release, RECORD_LABEL } from "./classes";

function getUndefiant(): Artist
{
	return new Artist(
		"Undefiant",
		"https://open.spotify.com/artist/0HHZoGGxhwl5My16mWggVP",
		"https://music.apple.com/artist/undefiant/1550927203",
		"https://music.apple.com/artist/undefiant/1550927203",
		"https://www.youtube.com/@undefiant",
		"https://music.youtube.com/channel/UCORL86zftmLBcYwHRUUxzqA",
		"https://soundcloud.com/undefiant_frenchcore",
		"https://www.instagram.com/undefiant_frenchcore",
		"https://amazon.com/music/player/artists/B07FBK9MTZ/undefiant",
		"https://www.deezer.com/artist/142412892",
		"https://www.hardtunes.com/artists/undefiant",
		"https://hardstyle.com/en/music?artist=Undefiant",
		"https://www.beatport.com/artist/undefiant/956338",
		"https://www.facebook.com/undefiant",
	)
}

function getMelolife(): Artist
{
	return new Artist(
		"Melolife",
		"https://open.spotify.com/artist/0FO6VRKZDFUckHWPLHptoQ",
		"https://music.apple.com/artist/melolife/1502392558",
		"https://music.apple.com/artist/melolife/1502392558",
		"https://www.youtube.com/@MelolifeOfficial",
		"https://music.youtube.com/channel/UC9L6cl5ek3FvHqdDyd6Wbdw",
		"https://soundcloud.com/melolife",
		"https://www.instagram.com/melolifedj",
		"https://www.amazon.com/music/player/artists/B085QL7Z9R/melolife",
		"https://www.deezer.com/artist/87988322",
		"",
		"https://hardstyle.com/en/music?artist=MELOLIFE",
		"https://www.beatport.com/artist/melolife/851395",
		"https://www.facebook.com/Melolifedj",
	)
}

function getQuarkee(): Artist
{
	return new Artist(
		"Quarkee",
		"https://open.spotify.com/artist/1NQPJdIztOWNObtnFy3hvY",
		"https://music.apple.com/artist/quarkee/1493457275",
		"https://music.apple.com/artist/quarkee/1493457275",
		"https://www.youtube.com/@quarkee9656",
		"https://music.youtube.com/channel/UCpt2LpCVRROMNo9Rv3djGSA",
		"https://soundcloud.com/quarkee",
		"https://www.instagram.com/quarkeemusic",
		"https://www.amazon.com/music/player/artists/B083HP5QQV/quarkee",
		"https://www.deezer.com/us/artist/82498782",
		"",
		"https://hardstyle.com/en/music?artist=Quarkee",
		"https://www.beatport.com/artist/quarkee/1120033",
		"https://www.facebook.com/p/Quarkee-100066315470858/",
	)
}

function getRelianze(): Artist
{
	return new Artist(
		"Relianze",
		"https://open.spotify.com/artist/0aoguuz5v4gKyb2ZRO3vYk",
		"https://music.apple.com/artist/relianze/1485868903",
		"https://music.apple.com/artist/relianze/1485868903",
		"https://www.youtube.com/@Relianze",
		"https://music.youtube.com/channel/UCWdERG8AAdpWB0XPGfHgirQ",
		"https://soundcloud.com/relianze",
		"https://www.instagram.com/relianze_official",
		"https://www.amazon.com/music/player/artists/B07Z6HLYCJ/relianze",
		"https://www.deezer.com/us/artist/76425162",
		"",
		"https://hardstyle.com/en/music?artist=Relianze",
		"https://www.beatport.com/artist/relianze/818430",
		"https://www.facebook.com/Relianzeofficial",
	)
}

function getDort(): Artist
{
	return new Artist(
		"D'ort",
		"https://open.spotify.com/artist/7H96PqbTkVRtQTdBNtiljh",
		"https://music.apple.com/artist/dort/1476390752",
		"https://music.apple.com/artist/dort/1476390752",
		"",
		"https://music.youtube.com/channel/UC4ns83V7qPvsl9prefJSRDw",
		"https://soundcloud.com/dort-music",
		"https://www.instagram.com/thisisdort",
		"https://www.amazon.com/music/player/artists/B07WDNN2Y4/d'ort",
		"https://www.deezer.com/us/artist/71719662",
		"https://www.hardtunes.com/artists/dort",
		"https://hardstyle.com/en/music?artist=D%27Ort",
		"https://www.beatport.com/artist/dort/908468",
		"https://www.facebook.com/thisisdort",
	)
}

export const RELEASES: Release[] = [
	new Release(
		"Leave Our Mark",
		[
			getUndefiant()
		],
		new Date("2025-01-30"),
		RECORD_LABEL.UNDEFIANT,
		"Undefiant - Leave Our Mark.wav",
		"https://open.spotify.com/track/6Qe2oq3LnztkuMSK6ltgIP",
		"https://music.apple.com/album/leave-our-mark-single/1870461566",
		"https://music.apple.com/album/leave-our-mark-single/1870461566",
		"", // TODO: YouTube
		"https://music.youtube.com/watch?v=qvmFEgv0S_A",
		"",
		"https://www.deezer.com/album/900889702",
		"https://music.amazon.com/tracks/B0GHQJ8RS4",
		"",
		""
	),
	new Release(
		"Heroes of the Hard",
		[
			getMelolife(),
			getUndefiant(),
		],
		new Date("2024-01-24"),
		RECORD_LABEL.UNIFYD_RECORDS,
		"Melolife & Undefiant - Heroes of the Hard (Extended Mix).wav",
		"https://open.spotify.com/track/6qqKNQLfbWbsJQ7vbXD3yd",
		"https://music.apple.com/album/heroes-of-the-hard/1791584221",
		"https://music.apple.com/album/heroes-of-the-hard/1791584221",
		"", // TODO: YouTube
		"https://music.youtube.com/watch?v=jxz8Ri2LpbQ",
		"",
		"",
		"",
		"",
		"https://www.beatport.com/release/heroes-of-the-hard/5872302"
	),
	new Release(
		"Skyline",
		[
			getUndefiant(),
			getQuarkee()
		],
		new Date("2024-12-13"),
		RECORD_LABEL.NRG_ATTK,
		"Undefiant & Quarkee - Skyline.wav",
		"https://open.spotify.com/track/6qqKNQLfbWbsJQ7vbXD3yd",
		"https://music.apple.com/album/skyline/1784410385",
		"https://music.apple.com/album/skyline/1784410385",
		"", // TODO: YouTube
		"https://music.youtube.com/watch?v=jxz8Ri2LpbQ",
		"https://soundcloud.com/undefiant_frenchcore/skyline",
		"https://music.amazon.com/tracks/B0DPTGQZNZ",
		"https://www.deezer.com/album/682337471",
		"",
		"",
		""
	),
	new Release(
		"Distant Dreams",
		[
			getUndefiant(),
		],
		new Date("2024-11-21"),
		RECORD_LABEL.RAPTURE_RECORDS,
		"Undefiant - Distant Dreams (Extended Mix).wav",
		"https://open.spotify.com/track/4iLl8DjtVSSHibqJGCh4ZL",
		"https://music.apple.com/album/distant-dreams/1778675953",
		"https://music.apple.com/album/distant-dreams/1778675953",
		"https://youtu.be/pwDV6PkvgKw", // TODO: YouTube
		"https://music.youtube.com/watch?v=y-lzIl5MZSU",
		"https://soundcloud.com/undefiant_frenchcore/distant-dreams",
		"https://music.amazon.com/tracks/B0DM9PKQKJ",
		"https://www.deezer.com/us/album/666915901",
		"https://www.hardtunes.com/tunes/undefiant-distant-dreams-radio-edit/87804",
		"https://hardstyle.com/en/tracks/c8e84d7b-7142-44d5-a906-a9da5faa446d/distant-dreams",
		"https://www.beatport.com/release/distant-dreams-extended-mix/4817908"
	),
	new Release(
		"Odyssey",
		[
			getRelianze(),
			getUndefiant(),
		],
		new Date("2023-08-11"),
		RECORD_LABEL.RELIANZE,
		"Relianze & Undefiant - Odyssey (Extended Mix).wav",
		"https://open.spotify.com/track/1jlSUOWgZA0ioh8blY1Le9",
		"https://music.apple.com/album/odyssey/1700387907",
		"https://music.apple.com/album/odyssey/1700387907",
		"https://youtu.be/GlzZkMqRKxo", // TODO: Change this to my own
		"https://music.youtube.com/watch?v=GlzZkMqRKxo",
		"https://soundcloud.com/undefiant_frenchcore/relianze-undefiant-odyssey",
		"https://music.amazon.com/albums/B0CD9S3VR6",
		"https://www.deezer.com/us/track/2390780475",
		"",
		"",
		"https://www.beatport.com/release/odyssey-extended-mix/4218230"
	),
	new Release(
		"Olympus",
		[
			getUndefiant(),
		],
		new Date("2023-02-03"),
		RECORD_LABEL.QDANCE_NEXT,
		"Undefiant - Olympus (Extended Mix).wav",
		"https://open.spotify.com/track/4ITTSSQ5RTqLqF9ldhpQul",
		"https://music.apple.com/album/olympus/1667208179",
		"https://music.apple.com/album/olympus/1667208179",
		"https://youtu.be/hXGxxzPTx9g", // TODO: Change this to my own. Don't know if it would even be allowed.
		"https://music.youtube.com/watch?v=hXGxxzPTx9g",
		"https://soundcloud.com/q-dancemusic/undefiant-olympus",
		"https://music.amazon.com/albums/B0BSTZ94LN",
		"https://www.deezer.com/track/2119749337",
		"https://www.hardtunes.com/tunes/undefiant-olympus/67260",
		"https://hardstyle.com/en/albums/daf2b0ab-1214-40f1-a1bf-0aece4278683/Olympus",
		"https://www.beatport.com/track/olympus/17340345"
	),
	new Release(
		"Take my Hand",
		[
			getUndefiant(),
		],
		new Date("2022-07-08"),
		RECORD_LABEL.RAPTURE_RECORDS,
		"Undefiant - Take My Hand (Extended Mix).wav",
		"https://open.spotify.com/track/6za4Wn6xwrJUKt51dIVxo6",
		"https://music.apple.com/album/take-my-hand/1632889419",
		"https://music.apple.com/album/take-my-hand/1632889419",
		"", // TODO: YouTube
		"https://music.youtube.com/watch?v=Z4vk1aVYp1o",
		"https://soundcloud.com/undefiant_frenchcore/undefiant-take-my-hand",
		"https://music.amazon.com/albums/B0B5PMBR74",
		"https://www.deezer.com/album/332673787",
		"https://www.hardtunes.com/tunes/undefiant-take-my-hand-original-mix/63741",
		"https://hardstyle.com/en/tracks/b71f42c2-966c-4b59-bb13-1b7cb0b2e2a8/take-my-hand",
		"https://www.beatport.com/release/take-my-hand-extended-mix/3797357"
	),
	new Release(
		"Legacy",
		[
			getUndefiant(),
			getMelolife(),
		],
		new Date("2022-07-08"),
		RECORD_LABEL.RAPTURE_RECORDS,
		"Undefiant & Melolife - Legacy (Extended Mix).wav",
		"https://open.spotify.com/track/6hee11HYePqqaMg8ivHm3L",
		"https://music.apple.com/album/legacy/1632889419",
		"https://music.apple.com/album/legacy/1632889419",
		"", // TODO: YouTube
		"https://music.youtube.com/watch?v=jLz8yCi8pyQ",
		"https://soundcloud.com/undefiant_frenchcore/undefiant-melolife-legacy",
		"https://music.amazon.com/albums/B0B5PMBR74",
		"https://www.deezer.com/album/332673787",
		"https://www.hardtunes.com/tunes/undefiant-and-melolife-legacy-original-mix/63742",
		"https://hardstyle.com/en/tracks/e4bcf862-27a0-4a5a-bda6-e32f2d1f676d/legacy",
		"https://www.beatport.com/release/take-my-hand-extended-mix/3797357"
	),
	new Release(
		"If I Fall",
		[
			getUndefiant(),
		],
		new Date("2022-01-28"),
		RECORD_LABEL.RAPTURE_RECORDS,
		"Undefiant - If I Fall (Extended Mix).wav",
		"https://open.spotify.com/track/3ye4qZdEN9JmNm3DnXAD7u",
		"https://music.apple.com/album/if-i-fall/1605759505",
		"https://music.apple.com/album/if-i-fall/1605759505",
		"", // TODO: YouTube
		"https://music.youtube.com/watch?v=hUBCU8OubnE",
		"https://soundcloud.com/undefiant_frenchcore/undefiant-if-i-fall",
		"https://music.amazon.com/albums/B09QLDKQZ2",
		"https://www.deezer.com/album/288266242",
		"https://www.hardtunes.com/albums/undefiant-if-i-fall/12595",
		"https://hardstyle.com/en/tracks/81b35164-ce93-4e1e-99a0-8000e41ffb3d/if-i-fall",
		"https://www.beatport.com/release/if-i-fall-extended-mix/3628263"
	),
	new Release(
		"Be My Light",
		[
			getUndefiant(),
		],
		new Date("2021-11-05"),
		RECORD_LABEL.RAPTURE_RECORDS,
		"Undefiant - Be My Light (Extended Mix).wav",
		"https://open.spotify.com/track/2G9wYo1NjhoaM0xbwpyWjc",
		"https://music.apple.com/album/be-my-light/1592652685",
		"https://music.apple.com/album/be-my-light/1592652685",
		"", // TODO: YouTube
		"https://music.youtube.com/watch?v=fUnmS-Zf7zY",
		"https://soundcloud.com/undefiant_frenchcore/be-my-light",
		"https://music.amazon.com/albums/B09KLVXSK9",
		"https://www.deezer.com/album/268694932",
		"https://www.hardtunes.com/tunes/undefiant-be-my-light-original-mix/59149",
		"https://hardstyle.com/en/tracks/59edb7b8-ab83-4054-95fa-0f6edc37a6b1/be-my-light",
		"https://www.beatport.com/track/be-my-light/15882355"
	),
	new Release(
		"Wild Love",
		[
			getUndefiant(),
		],
		new Date("2021-08-20"),
		RECORD_LABEL.RAPTURE_RECORDS,
		"Undefiant - Wild Love (Extended Mix).wav",
		"https://open.spotify.com/track/2uJMSiu0XWwo9uvQPRybvu",
		"https://music.apple.com/album/wild-love/1581772686",
		"https://music.apple.com/album/wild-love/1581772686",
		"https://youtu.be/dHDDiNPhOfA",
		"https://music.youtube.com/watch?v=uGN5gQdOS7s",
		"https://soundcloud.com/undefiant_frenchcore/wild-love",
		"https://music.amazon.com/albums/B09CWBJWZV",
		"https://www.deezer.com/album/252377222",
		"https://www.hardtunes.com/tunes/undefiant-wild-love-original-mix/57853",
		"https://hardstyle.com/en/tracks/52a259c0-e004-46c9-818e-8b3640f519b0/wild-love",
		"https://www.beatport.com/track/wild-love/15620897"
	),
	new Release(
		"First Light",
		[
			getDort(),
			getUndefiant(),
		],
		new Date("2021-01-29"),
		RECORD_LABEL.RAPTURE_RECORDS,
		"D'ort & Undefiant - First Light (Extended Mix).wav",
		"https://open.spotify.com/track/4KAj9Lcfg8xicgj4oqa8AF",
		"https://music.apple.com/album/first-light/1550930207",
		"https://music.apple.com/album/first-light/1550930207",
		"https://youtu.be/utyYhncHGnI",
		"https://music.youtube.com/watch?v=I3CLFHjb0K4",
		"https://soundcloud.com/dort-music/dort-undefiant-first-light-1",
		"https://music.amazon.com/albums/B08V1X3FDR",
		"https://www.deezer.com/album/202886952",
		"https://www.hardtunes.com/tunes/dort-and-undefiant-first-light-original-mix/53961",
		"https://hardstyle.com/en/tracks/c3de446f-9168-4cd6-b0d0-afdaaf4e65b1/first-light",
		"https://www.beatport.com/release/redemption-original-mix/3270096"
	),
	// new Release(
	// 	"name",
	// 	[
	// 		getUndefiant(),
	// 	],
	// 	new Date("2024-01-24"),
	// 	RECORD_LABEL.NRG_ATTK,
	// 	"spotify",
	// 	"appleMusic",
	// 	"iTunes",
	// 	"youtube",
	// 	"youtubeMusic",
	// 	"soundcloud",
	// 	"amazon",
	// 	"deezer",
	// 	"hardtunes",
	// 	"hardstyle.com",
	// 	"beatport"
	// ),
];

const CURRENT_DATE: Date = new Date();
const BIRTHDAY: Date = new Date('January 25, 2000 00:00:00');

export const CURRENT_YEAR = () => {
	return CURRENT_DATE.getFullYear();
};

export const AGE = () => {
	const today = new Date();
	let age = today.getFullYear() - BIRTHDAY.getFullYear();
	const m = today.getMonth() - BIRTHDAY.getMonth();
	if (m < 0 || (m === 0 && today.getDate() < BIRTHDAY.getDate())) {
		age--;
	}
	return age; // Return an object with the calculated age
};

export const UNDEFIANT = getUndefiant();